import React from "react";
import "./YoutubeEmbed";
import YoutubeEmbed from "./YoutubeEmbed";

export default function Video() {
  return (
    <div className="video">
      <h1>Adventure Awaits...</h1>
      <YoutubeEmbed embedId="wJF5NXygL4k" />
    </div>
  );
}
